export default "__VITE_ASSET__B4rlg0Et__"